import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {ComplianceDirectorView} from '@modifi/onboarding-api-clients'

import reducer from './collection'

export default reducer

export type DirectorsState = KeyWindowState<ComplianceDirectorView>
